//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';

    angular.module('container.core')
        .factory('advancedSearchService', advancedSearchService);

    function advancedSearchService() {
        let map = new Map();

        function storeData(key, value) {
            map.set(key, value);
        }
        function retrieveData(key) {
            return map.get(key);
        }

        return {
            storeData: storeData,
            retrieveData: retrieveData
        };

    }

})();